import React, { type Ref, useContext } from 'react';
import StyledPhaseColumn from './StyledPhaseColumn';
import PhaseContext from '../../../PhaseContext';
import VisiblePhaseContext from '@/components/ChallengePortfolio/VisiblePhaseContext';

type PhaseColumnProps = {
  hasItems: boolean;
  inTaskBoard?: boolean;
  collapsed?: boolean;
  children: React.ReactNode;
  ref: Ref<HTMLDivElement>;
};

const PhaseColumn = ({
  hasItems,
  inTaskBoard,
  collapsed,
  children,
  ref,
}: PhaseColumnProps) => {
  const phase = useContext(PhaseContext);
  const { visibleChallengePhase, visibleTaskPhase } =
    useContext(VisiblePhaseContext);
  const visiblePhase = inTaskBoard ? visibleTaskPhase : visibleChallengePhase;

  return (
    <StyledPhaseColumn
      hasItems={hasItems}
      inTaskBoard={inTaskBoard ?? false}
      collapsed={collapsed ?? false}
      invisible={phase !== visiblePhase}
      ref={ref}
    >
      {children}
    </StyledPhaseColumn>
  );
};

export default PhaseColumn;
